var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { RemoveCustomFieldApi } from './apis/remove-custom-field-api.interface';
let RemoveCustomFieldRepositoryImpl = class RemoveCustomFieldRepositoryImpl {
    constructor(removeCustomFieldApi) {
        this.removeCustomFieldApi = removeCustomFieldApi;
    }
    removeCustomField(customFieldIds) {
        return this.removeCustomFieldApi.removeCustomField(customFieldIds);
    }
};
RemoveCustomFieldRepositoryImpl = __decorate([
    injectable(),
    __param(0, inject(RemoveCustomFieldApi)),
    __metadata("design:paramtypes", [typeof (_a = typeof RemoveCustomFieldApi !== "undefined" && RemoveCustomFieldApi) === "function" ? _a : Object])
], RemoveCustomFieldRepositoryImpl);
export { RemoveCustomFieldRepositoryImpl };
